import React from "react";
import "./LegalPages.scss";

/**
 * Politique d'Abonnement & Paiement – ReviewBoost AI
 * Version: 25 septembre 2025
 */
const PaymentsBilling = () => (
  <div className="legal-page">
    <h1>Abonnements, Paiements & Remboursements</h1>
    <p>Dernière mise à jour : 25 septembre 2025</p>

    <h2>1. Plans et tarifs</h2>
    <ul>
      <li><strong>Essai Gratuit :</strong> 14 jours, 1 emplacement, accès complet, support par email.</li>
      <li><strong>Basic :</strong> 19&nbsp;€/mois – jusqu’à 3 emplacements, réponses IA illimitées, QR codes personnalisés, alertes in-app, support email.</li>
      <li><strong>Pro :</strong> 39&nbsp;€/mois – inclut tout le Basic + jusqu’à 10 emplacements, alertes par email, affiches (logo+QR) export PNG/PDF, analytics avancés, support prioritaire.</li>
    </ul>
    <p>
      Sauf indication contraire, les prix sont affichés <strong>TTC (TVA incluse si applicable)</strong> et peuvent être modifiés
      avec préavis raisonnable. Tout changement de prix n’affecte pas une période déjà payée.
    </p>

    <h2>2. Période d’essai</h2>
    <p>
      L’essai gratuit de 14 jours ne nécessite pas de paiement immédiat. À l’issue de l’essai, si vous
      choisissez un plan payant, l’abonnement démarre au tarif en vigueur. Vous pouvez annuler
      à tout moment avant la fin de l’essai pour éviter toute facturation.
    </p>

    <h2>3. Facturation & renouvellement</h2>
    <ul>
      <li>La facturation est <strong>mensuelle</strong> et se renouvelle automatiquement jusqu’à résiliation.</li>
      <li>Une <strong>facture</strong> est émise à chaque paiement et envoyée par email.</li>
      <li>Les paiements sont traités de manière sécurisée par notre prestataire (ex.&nbsp;Stripe).</li>
    </ul>

    <h2>4. Mise à niveau / rétrogradation</h2>
    <ul>
      <li><strong>Upgrade vers Pro :</strong> l’accès aux fonctionnalités Pro est activé dès la mise à niveau. La facturation est ajustée à partir de la période suivante (proratisation si applicable).</li>
      <li><strong>Downgrade vers Basic :</strong> effectif à la prochaine échéance. Les fonctionnalités Pro restent actives jusqu’à la fin de la période en cours.</li>
    </ul>

    <h2>5. Échec de paiement</h2>
    <p>
      En cas d’échec de paiement, nous effectuons plusieurs nouvelles tentatives. À défaut de
      régularisation sous 7&nbsp;jours, l’accès au service peut être <strong>suspendu</strong> jusqu’au règlement.
    </p>

    <h2>6. Annulation</h2>
    <ul>
      <li>Vous pouvez <strong>annuler à tout moment</strong> depuis votre compte (section Abonnement).</li>
      <li>L’annulation prend effet à la fin de la période en cours. <strong>Aucun remboursement au prorata</strong> n’est dû pour la période entamée.</li>
    </ul>

    <h2>7. Remboursements</h2>
    <ul>
      <li>Hors obligations légales, les montants déjà payés ne sont pas remboursables.</li>
      <li>
        Droit de rétractation (UE) : pour les services numériques fournis immédiatement après votre consentement
        exprès, le droit de rétractation peut ne pas s’appliquer. Si applicable, il est de 14&nbsp;jours à compter de
        l’achat, sous réserve que le service n’ait pas commencé.
      </li>
    </ul>

    <h2>8. Taxes</h2>
    <p>
      Les taxes (ex.&nbsp;TVA) sont appliquées selon la réglementation en vigueur et votre pays de facturation.
      Les prix affichés incluent la TVA si applicable.
    </p>

    <h2>9. Utilisation équitable</h2>
    <p>
      Les réponses IA sont «&nbsp;illimitées&nbsp;» dans le cadre d’un usage raisonnable et non abusif. Nous pouvons appliquer
      des limites techniques temporaires pour protéger la stabilité du service.
    </p>

    <h2>10. Litiges & rétrofacturations</h2>
    <p>
      En cas de litige de paiement, contactez-nous d’abord pour une résolution amiable. Toute rétrofacturation
      injustifiée peut entraîner la suspension du compte.
    </p>

    <h2>11. Contact facturation</h2>
    <p>
      Pour toute question liée à la facturation&nbsp;: <a href="mailto:sbdev42@gmail.com">sbdev42@gmail.com</a>
    </p>
  </div>
);

export default PaymentsBilling;
